import { initializeApp } from 'firebase/app';
import { getMessaging, isSupported } from 'firebase/messaging';
import { getAuth, GoogleAuthProvider } from 'firebase/auth';
import { portalEnv } from '../config/portalEnv';

const firebaseConfig = portalEnv.firebase;

const app = initializeApp(firebaseConfig);
let messaging = getMessaging(app);
const auth = getAuth(app);
const provider = new GoogleAuthProvider();

export { auth, provider, messaging };

export const initFirebaseMessaging = async () => {
  if (messaging) return messaging;

  const supported = await isSupported();
  if (supported) {
    messaging = getMessaging(app);
    console.log('Firebase Messaging initialized for web.');
    return messaging;
  }
  return null;
};

export const getFirebaseMessaging = () => messaging;
